import * as React from 'react'
import { MentionLink } from './MentionLink'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const MentionLinkExamples = () => {
  return (
    <div className="MentionLinkExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MentionLink />
      </Provider>
    </div>
  )
}
